<template>
  <div class="login">
    <h1>おくすりナビゲーション</h1>
    <h3>ログイン</h3>
    <form @submit.prevent="login">
      <div>
        <label>ID:</label>
        <input type="text" placeholder="" v-model="username" required>
      </div>
      <div>
        <label>パスワード:</label>
        <input type="password" placeholder="" v-model="password" required>
      </div>
      <button>ログイン</button>
    </form>
    <img src="../assets/wetan_logo.png" width=222 height=192>
    <br>
    <button @click="openPdf" class="pdf-link">マニュアル (PDF)</button>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      pdfUrl: `https://${location.hostname}/static_contents/pdf/okusuri_manual.pdf`
    }
  },
  methods: {
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
            console.log("Login Success")
            this.$cognito.postLoginSuccess(result)
        })
        .then(err => {
            this.error = err
        })
    },
    openPdf () {
      window.open(this.pdfUrl, '_blank')
    }
  }
}
</script>

<style>
label {
    display: inline-block;
    font-weight:bold;
    text-align: right;
    width: 100px;
}
button {
  margin: 10px;
  height: 30px;
  width: 120px;
  border-radius: 15px 15px 15px 15px;
  border: 0px;
  background-color: rgb(64, 144, 236);
  font-weight: bold;
  font-size: medium;
  font-family: monospace;
  color: white;
  cursor: pointer;
}
.pdf-link {
  margin: 10px;
  height: 50px;
  width: 160px;
  border-radius: 25px 25px 25px 25px;
  border: 2px solid rgb(64, 144, 236);
  background-color: white;
  font-weight: bold;
  font-size: large;
  font-family: monospace;
  color: rgb(64, 144, 236);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue